import { Controller } from "stimulus";

export default class extends Controller {
	static targets = ["popoverContent"];

	connect() {
    this.isOpen = false;
    this.autoDismissTimeout = null;
		console.log("Popover connected");
	}

  mouseenter() {
    if (this.isTouchDevice()) return;
    if (this.isOpen) return;
    this.showAndPosition();
  }
  
  click(e) {
    if (!this.isTouchDevice()) return;
    if (this.isOpen) return this.onClose();
    e.preventDefault();
    this.showAndPosition();
  }
  
  showAndPosition() {
    this.isOpen = true;
    const content = this.popoverContentTarget;
    content.classList.add("is-visible");
    
		requestAnimationFrame(() => {
			const rect = content.getBoundingClientRect();
			const viewportWidth = window.visualViewport?.width;
      
			const overflowLeft = rect.left < 0;
			const overflowRight = rect.right > viewportWidth;
      
			this.reset();
      
			if (overflowLeft || overflowRight) {
				if (viewportWidth <= 370) {
					content.style.left = "50%";
					content.style.transform = "translateX(-50%)";
				} else {
					content.style.left = "80%";
					content.style.transform = "translateX(-80%)";
				}
			}
		});
  }

	mouseleave() {
		if (this.isTouchDevice()) return;
    this.onClose();
	}

  onClose() {
    this.isOpen = false;
    const content = this.popoverContentTarget;
    content.classList.remove("is-visible");
    this.reset();
  }

  showAndAutoDismiss() {
    // If already open, close it immediately
    if (this.isOpen) {
      this.onClose();
      return;
    }

    // Clear any existing timeout
    if (this.autoDismissTimeout) {
      clearTimeout(this.autoDismissTimeout);
    }

    this.isOpen = true;
    const content = this.popoverContentTarget;
    content.classList.add("is-visible");
    
    requestAnimationFrame(() => {
      // Mobile screens (max-width: 768px)
      if (window.innerWidth <= 768) {
        const iconRect = this.element.getBoundingClientRect();
        let top = iconRect.bottom + 12;
        let left = iconRect.left + iconRect.width / 2;
        
        // Center the popover on the icon
        // Assuming ~280px max-width, use half of that (~140px)
        left = left - 140;
        
        // Ensure popover doesn't go off-screen on the right
        if (left + 280 > window.innerWidth - 10) {
          left = window.innerWidth - 280 - 10;
        }
        
        // Ensure popover doesn't go off-screen on the left
        if (left < 10) {
          left = 10;
        }
        
        content.style.top = top + "px";
        content.style.left = left + "px";
      } else {
        // Desktop/iPad (larger screens) - reset to absolute positioning
        this.reset();
      }
    });

    // Auto dismiss after 3.5 seconds
    this.autoDismissTimeout = setTimeout(() => {
      this.onClose();
      this.autoDismissTimeout = null;
    }, 3500);
  }

	reset() {
		const content = this.popoverContentTarget;
		content.style.top = "";
		content.style.left = "";
		content.style.right = "";
		content.style.transform = "";
	}

  isTouchDevice() {
    return window.matchMedia("(hover: none)").matches;
  }
}
